import DixaIcon from '@dixa/dixa-modern-icons';
import { accessControl } from 'lib-shared-access-control';
import { AsyncStatus } from 'lib-shared-legacy-types';
import {
  formatInternational,
  getCountryCodeFromPhoneNumber,
} from 'lib-shared-phone-numbers';
import { Component } from 'react';
import Collapsible from 'react-collapsible';
import { Link } from 'react-router-dom';

import PhoneNumbersCustomInput from 'components/topbar/telephony/components/PhoneNumbersCustomInput';

import SimpleListNumbers from '../../simpleListNumbers/SimpleListNumbers';

type PropsT = {
  meta: {
    asyncStatus: AsyncStatus;
  };
  roles: Array<any> | null;
  dynamicTelephoneNumbersArray: Array<any> | null;
  staticTelephoneNumbersArray: Array<any> | null;
  currentDefaultNumber: string | null;
  previousPage: string | null;
  nextPage: string | null;
  open: boolean;
  selectingDefault: boolean | null;
  changeDefaultNumber: (number: string) => void;
  getNumbersByQuery: (payload: any) => Promise<void>;
  toggleDropdown: (payload: boolean) => void;
};

export default class OwnNumbersDropDownButton extends Component<PropsT> {
  constructor(props: PropsT) {
    super(props);
  }

  toggleDropdown = () => {
    if (this.props.open) {
      this.props.toggleDropdown(false);
    } else {
      this.props.toggleDropdown(true);
    }
  };

  changeNumber = (number: any = null) => {
    if (!number) {
      console.error('changeNumber no number params given.', number);
      return;
    }
    this.props.changeDefaultNumber(number);
    this.toggleDropdown();
  };

  render() {
    let disabledPrevious = '';
    let disabledNext = '';
    let previousLink: JSX.Element | null = null;
    let nextLink: JSX.Element | null = null;
    let phoneNumberFormat: JSX.Element | string = (
      <p className="no-number-selected">no number selected yet</p>
    );
    let regionCode = '';
    let helpText: JSX.Element | string = '';
    const { currentDefaultNumber } = this.props;

    if (currentDefaultNumber) {
      phoneNumberFormat =
        formatInternational(currentDefaultNumber || undefined) ||
        currentDefaultNumber;
      regionCode =
        (
          getCountryCodeFromPhoneNumber(currentDefaultNumber) || ''
        ).toUpperCase() || 'Unknown';
    }

    if (this.props.previousPage === null) {
      disabledPrevious = 'disabled';
      previousLink = (
        <a type="button" className="disabled">
          <span style={{ verticalAlign: '-2px' }}>
            <DixaIcon icon="arrow-left" />
          </span>
          Prev Page
        </a>
      );
    } else {
      previousLink = (
        <a
          type="button"
          style={{ cursor: 'pointer' }}
          onClick={() =>
            this.props.getNumbersByQuery({
              query: { path: this.props.previousPage, limit: '15' },
            })
          }
        >
          <span style={{ verticalAlign: '-2px' }}>
            <DixaIcon icon="arrow-left" />
          </span>
          Prev Page
        </a>
      );
    }

    if (this.props.nextPage === null) {
      disabledNext = 'disabled';
      nextLink = (
        <a type="button" className="disabled">
          Next page
          <span style={{ verticalAlign: '-2px' }}>
            <DixaIcon icon="arrow-right" />
          </span>
        </a>
      );
    } else {
      nextLink = (
        <a
          type="button"
          style={{ cursor: 'pointer' }}
          onClick={() =>
            this.props.getNumbersByQuery({
              query: { path: this.props.nextPage, limit: '15' },
            })
          }
        >
          Next page
          <span style={{ verticalAlign: '-2px' }}>
            <DixaIcon icon="arrow-right" />
          </span>
        </a>
      );
    }

    if (
      this.props.dynamicTelephoneNumbersArray &&
      this.props.dynamicTelephoneNumbersArray.length === 0 &&
      this.props.staticTelephoneNumbersArray &&
      this.props.staticTelephoneNumbersArray.length === 0
    ) {
      let link: JSX.Element | null = null;
      if (
        accessControl.hasAccess('settings.integration.channel.setup', {
          fallbackRole: 'admin',
        })
      ) {
        link = (
          <Link to="/settings/phone">
            Get your free number in settings/phone.
          </Link>
        );
      }
      helpText = (
        <p>
          Before you can receive calls, you need to buy a phone number. {link}
        </p>
      );
    }

    return (
      <div className={`collapsible-holder flags`}>
        <div className="selected-number-label">Selected number</div>
        <div className={'selected flag ' + regionCode.toLowerCase()}></div>
        <span className="number-selected">{phoneNumberFormat}</span>
        {this.props.dynamicTelephoneNumbersArray &&
        this.props.dynamicTelephoneNumbersArray.length === 0 &&
        this.props.staticTelephoneNumbersArray &&
        this.props.staticTelephoneNumbersArray.length === 0 ? (
          <div>
            <li role="separator" className="divider"></li>
            {helpText}
          </div>
        ) : (
          <Collapsible
            handleTriggerClick={this.toggleDropdown}
            open={this.props.open}
            transitionTime={300}
            trigger=""
            easing="ease"
          >
            <div className="own-number-change dropdown-header" role="heading">
              Search organization numbers
            </div>
            <PhoneNumbersCustomInput
              telephonyGetQueryNumbers={this.props.getNumbersByQuery}
            />
            <div
              className={`own-number-change select-flow-number dropdown-header`}
              role="heading"
            >
              Select number
            </div>
            {this.props.meta.asyncStatus === 'loading' ? (
              <p>Loading...</p>
            ) : (
              <SimpleListNumbers
                selectingDefault={this.props.selectingDefault}
                dynamicTelephoneNumbersArray={
                  this.props.dynamicTelephoneNumbersArray as any[]
                }
                onToggle={this.toggleDropdown}
                selectedFromNumber={this.props.currentDefaultNumber}
                changeFromNumber={this.changeNumber}
              />
            )}
            {(this.props.meta.asyncStatus === 'loading' && (
              <ul className={`pager`} style={{ margin: 'auto' }}>
                <li className="disabled pull-left">
                  {
                    <a type="button">
                      {' '}
                      <span style={{ verticalAlign: '-2px' }}>
                        <DixaIcon icon="arrow-left" />
                      </span>
                      Loading{' '}
                    </a>
                  }
                </li>
                <li className="disabled pull-right">
                  {
                    <a type="button">
                      {' '}
                      Loading{' '}
                      <span style={{ verticalAlign: '-2px' }}>
                        {' '}
                        <DixaIcon icon="arrow-right" />{' '}
                      </span>
                    </a>
                  }
                </li>
              </ul>
            )) || (
              <ul className={`pager`} style={{ margin: 'auto' }}>
                <li className={disabledPrevious + ' previous'}>
                  {previousLink}
                </li>
                <li className={disabledNext + ' next'}>{nextLink}</li>
              </ul>
            )}
          </Collapsible>
        )}
      </div>
    );
  }
}
